import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
    Link,
    useNavigate,
    useSearchParams,
    Navigate,
    useLocation,
    Location
} from "react-router-dom";
import { BarteringDocument, BsUser, BsUserLoggedIn, Feedback, Listing, ProductTag, WithStringId, Notification } from './types';
import api from './api';



import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faYinYang, faCircle, faX, faInbox, faTv, faBell, faSquare } from '@fortawesome/free-solid-svg-icons'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'

import Logo from './logo.svg';
import './app.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Home, SearchPage, UserInventory } from './listings'
import { AccountRoute, LoginRoute, LogoutRoute, RegisterRoute } from './account';
import { ListFormRoute, ListSuccessRoute } from './createlisting'
import { Terms } from './terms';
import { FAQ } from './faq';
import { TradeCenter } from './tracecenter';
import classNames from 'classnames';
import localDatabase from './localsettings';
import { Orders } from './orders';
import Landing from './landing';


const App: FunctionComponent<{}> = ({ }) => {
    const [user, setUser] = useState(undefined as any as WithStringId<BsUserLoggedIn> | undefined);
    const [loaded, setLoaded] = useState(false);
    const [tags, setTags] = useState([] as Array<ProductTag>);
    const [roomTags, setRoomTags] = useState([] as Array<ProductTag>)
    const [showDisclaimer, setShowDisclaimer] = useState(localDatabase.getBoolean('showdisclaimer', true));
    const [showNav, setShowNav] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [barters, setBarters] = useState([] as Array<WithStringId<BarteringDocument>>);
    const [myListings, setMyListings] = useState([] as Array<WithStringId<Listing>>)
    const [listing, setCurrentListing] = useState(undefined as WithStringId<Listing> | undefined);
    const [notifications, setNotifications] = useState([] as Array<WithStringId<Notification<string>>>);

    const refreshUser = () => {
        api.me()
            .then(user => {
                console.log('Logged in:', user)
                setUser(user)
            })
            .catch(err => {
                setUser(undefined);
            })
            .then(() => setLoaded(true));
    }
    const refreshBarters = () => {
        api.activeBarters()
            .then(barters => {
                console.log('Barters:', barters)
                setBarters(barters)
            })
    }
    const refreshListings = () => {
        api.getPersonalListings(50, 1)
            .then(({ pages, listings }) => {
                setMyListings(listings);
            })
    }
    const refreshNotifications = () => {
        api.getNotifications()
            .then(notifications => setNotifications(notifications));
    }
    useEffect(() => {
        refreshBarters();
        refreshListings();
        refreshNotifications();
    }, [user])

    useEffect(() => {
        refreshUser();
        api.getTags()
            .then(tags => {
                console.log('Tags:', tags)
                setTags(tags);
            })
        api.getRoomTags()
            .then(tags => {
                console.log('Room Tags:', tags)
                setRoomTags(tags);
            })
    }, [])
    return <BrowserRouter>
        {true && ' ' || `<Header>
            <HeaderUser user={user} />
        </Header>`}
        <div className={'container-fluid '}>
            {showDisclaimer && <div className='alert alert-warning alert-dismissible'>
                This website is still in active development and in pre-alpha stage. Please submit feedback at the bottom of this page if you notice any issues
                <button type="button" className="btn-close" onClick={() => {
                    localDatabase.setBoolean('showdisclaimer', false);
                    setShowDisclaimer(false);
                }} />
            </div>}

            <Routes>
                <Route path='/' element={<Landing>
                </Landing>} />
                <Route path='/home' element={<Home
                    barters={barters}
                    roomTags={roomTags}
                    tags={tags}
                    refreshBarters={refreshBarters}
                    listing={listing}
                    readyToTrade={user && user.readyToTrade || false}
                    onListing={listing => setCurrentListing(listing)}>
                    {false && !!myListings.length && !listing && <UserInventory listings={myListings} onListing={listing => setCurrentListing(listing)} />}
                </Home>} />
                <Route path='/listing/:id' element={<Home
                    barters={barters}
                    tags={tags}
                    roomTags={roomTags}
                    readyToTrade={user && user.readyToTrade || false}
                    refreshBarters={refreshBarters}
                    listing={listing}
                    onListing={listing => setCurrentListing(listing)} />} />
                <Route path='/search' element={<SearchPage
                    listing={listing}
                    readyToTrade={user && user.readyToTrade || false}
                    onListing={listing => setCurrentListing(listing)}
                    barters={barters}
                    refreshBarters={refreshBarters}
                    tags={tags} />} />
                <Route path='/login' element={!user ? <LoginRoute onUser={nextUser => setUser(nextUser)} /> : <Navigate to='/home' />} />
                <Route path='/tradecenter' element={loaded && (user ? <TradeCenter refreshParentBarters={refreshBarters} user={user} tags={tags} /> : <Navigate to='/login' />)} />
                <Route path="/register" element={<RegisterRoute />} />
                <Route path='/account' element={loaded && (user ? <AccountRoute user={user} refreshUser={refreshUser} /> : <Navigate to='/login' />)} />
                <Route path='/logout' element={<LogoutRoute onUser={(nextUser => setUser(nextUser))} />} />
                <Route path='/list' element={loaded && (user ? <ListFormRoute tags={tags} /> : <Navigate to='/login' />)} />
                <Route path='/list/success/:id' element={<ListSuccessRoute />} />
                <Route path='/terms' element={<Terms />} />
                <Route path='/faq' element={<FAQ />} />
                <Route path='/orders' element={loaded && (user ? <Orders userId={user?._id || ''} /> : <Navigate to='/login' />)} />
            </Routes>
        </div>
        <FeedbackComponent />
        <Footer />
    </BrowserRouter>
}

const getLocationName = (location: Location) => {
    if (location.pathname.startsWith('/list'))
        return 'NEW LISTING'
    if (location.pathname.startsWith('/register'))
        return 'REGISTER';
    if (location.pathname.startsWith('/search'))
        return 'SEARCH';
    if (location.pathname.startsWith('/login'))
        return 'LOGIN'
    if (location.pathname.startsWith('/logout'))
        return 'LOGOUT'
    if (location.pathname.startsWith('/tradecenter'))
        return 'TRADE CENTER';
    if (location.pathname.startsWith('/account'))
        return 'ACCOUNT'
    if (location.pathname.startsWith('/orders'))
        return 'ORDERS'
    if (location.pathname.startsWith('/terms'))
        return 'TERMS'
    if (location.pathname.startsWith('/faq'))
        return 'FAQ'
    if (location.pathname.startsWith('/'))
        return 'HOME'
}

const Header: FunctionComponent<{}> = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [locationName, setLocationName] = useState(getLocationName(location));
    // when pathname == '/' we try to show as mimimal adjacent elements as possible
    const [showSearch, setShowSearch] = useState(
        location.pathname !== '/' && !['/list', '/terms', '/faq', '/account', '/login', '/register'].some(path =>
            location.pathname.startsWith(path))
    );

    useEffect(() => {
        setLocationName(getLocationName(location));
        setShowSearch(location.pathname !== '/' && !['/list', '/terms', '/faq', '/account', '/login', '/register'].some(path =>
            location.pathname.startsWith(path))
        );
    }, [location]);

    return <div>
        <nav className="navbar navbar-expand-lg navbar-light nav-color">
            <div className='container-fluid d-block mx-2'>
                <div className='row'>
                    <div className='col d-flex justify-content-start align-items-center cursor-pointer' onClick={() => navigate('/')}>
                        <span className='p-3'>
                            <img src={Logo} width={'60px'} height={'60px'} />
                        </span>
                        <h2 className='display-5'><strong>{locationName}</strong></h2>
                    </div>
                    <div className='col d-flex justify-content-center'>
                    </div>
                    <div className='col d-flex justify-content-end align-items-center'>
                        {children}
                    </div>
                </div>
            </div>
        </nav>
        <div className='nav-container'>
            <div className='nav-group'>
                <div className='nav-section nav-color nav-border' />
                <div className='nav-section' />
            </div>
            <div className='nav-group'>
                <div className='d-flex align-items-center justify-content-center'>
                    <div className='w-25'>
                        {showSearch && <Search />}
                    </div>
                </div>
            </div>
        </div>
    </div>
}
const HeaderUser: FunctionComponent<{ user?: WithStringId<BsUserLoggedIn> }> = ({ user }) => {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);




    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && show && !dropdownRef.current.contains(event.target as Node)) {
                setShow(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [show]);

    if (user) {
        const tag = user.username.split('#')[1];
        return <>
            <NotificationsComponent />
            <div className='dropdown' ref={dropdownRef}>
                <button style={{ border: '1px', background: 'transparent' }} className='p-2 dropdown-toggle' onClick={() => setShow(!show)}>
                    <h3 className='d-inline'><strong>{user.firstName.toUpperCase()}</strong> #<small>{tag}</small></h3>
                </button>
                <div className={"dropdown-menu " + (show ? 'show' : '')}>
                    <Link className='dropdown-item' to='/list'>Create listing</Link>
                    <Link className='dropdown-item' to='/orders'>Order</Link>
                    <Link className='dropdown-item' to='/tradecenter'>Trade Center</Link>
                    <Link className='dropdown-item' to='/account'>Account</Link>
                    <Link className='dropdown-item' to='/logout'>Logout</Link>
                </div>
            </div>
        </>
    } else {
        return <div style={{ border: '1px' }} className='d-inline-block p-2'>
            <button type="button" className="btn btn-outline-secondary mx-1" onClick={() => navigate('/login')}>LOGIN</button>
            <button type="button" className="btn btn-outline-secondary mx-1" onClick={() => navigate('/register')}>REGISTER</button>
        </div>
    }
}
const Search: FunctionComponent = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        if (!location.pathname.startsWith('/search')) {
            setSearchQuery('');
        }
    }, [location])
    useEffect(() => {
        if (searchQuery) {
            navigate('/search?query=' + searchQuery)
        }
    }, [searchQuery]);
    return <>
        <input type='search' className='form-control' placeholder='Search for Shirts, Pants, Accessories...' value={searchQuery} onChange={e => setSearchQuery(e.currentTarget.value)} />
    </>
}
const NotificationsComponent: FunctionComponent<{}> = ({ }) => {
    const [show, setShow] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const [notifications, setNotifications] = useState([] as Array<WithStringId<Notification<string>>>);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        api.getNotifications()
            .then(notifications => {
                setLoaded(true);
                setNotifications(notifications);
            })
            .catch(err => {

            })
            .then(() => setLoaded(true));
    }, [])

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && show && !dropdownRef.current.contains(event.target as Node)) {
                setShow(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [show]);

    return <div className='dropdown' ref={dropdownRef}>
        <button
            style={{ background: 'transparent', border: '1px' }}
            className="p-2 dropdown-toggle" onClick={() => setShow(!show)}>
            <FontAwesomeIcon icon={faBell} size='2x' />
        </button>

        <div className={"dropdown-menu " + (show ? 'show' : '')}>
            {notifications.map(notification => <div className='dropdown-item'>
                <div className='d-flex justify-content-between'>
                    <div>
                        <strong>{notification.workOrder}</strong>
                    </div>
                    <div>
                        <small>{new Date(notification.time).toLocaleDateString()}</small>
                    </div>
                </div>
                <div>
                    {notification.message}
                </div>
            </div>)}
            {!loaded || !notifications.length && <div className='dropdown-item'>
                <div className='d-flex justify-content-center'>
                    <small>No notifications</small>
                </div>
            </div>}
        </div>
    </div>
}

const Footer: FunctionComponent<{}> = () => {
    const navigate = useNavigate();
    return (
        <footer className="container mt-5 pt-5 border-top text-muted small bg-light">
            <div className="row">
                <div className="col-md-7 mb-3">
                    <h4>
                        <strong className='mx-2'>Backyard Swap</strong>
                        <a href="https://instagram.com/backyardswap" aria-label="Instagram">
                            <FontAwesomeIcon icon={faInstagram} />
                        </a>
                    </h4>

                </div>

                <div className="col-md-1 mb-3">
                    <h6>Help</h6>
                    <ul className="list-unstyled">
                        <li><a href="/faq" onClick={() => navigate('/terms')} className="text-muted">FAQ</a></li>
                    </ul>
                </div>

                <div className="col-md-2 mb-3">
                    <h6>Legal information</h6>
                    <ul className="list-unstyled">
                        <li><a href="#" className="text-muted">Data protection policy</a></li>
                        <li><a href="/terms" onClick={() => navigate('/terms')} className="text-muted">Terms of service</a></li>
                    </ul>
                </div>

                <div className="col-md-2 mb-3">
                    <h6>Contact information</h6>
                    <ul className="list-unstyled">
                        <li><a href="mailto:contact@backyardswap.com" className="text-muted">contact@backyardswap.com</a></li>
                        <li><span>(469) 659-9340</span></li>
                    </ul>
                </div>
            </div>
        </footer>
    );
};
const FeedbackComponent: FunctionComponent<{}> = ({ }) => {
    const [type, setType] = useState('');

    const [comments, setComments] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [ready, setReady] = useState(false);
    const [completed, setCompleted] = useState(false);

    const feedbackRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (type && comments && !ready) {
            setReady(true);
        }

        if ((!type || !comments) && ready) {
            setReady(false);
        }
    }, [type, comments])

    useEffect(() => {
        if (!showForm && completed) {
            setType('')
            setComments('')
            setReady(false);
            setCompleted(false);
        }
    }, [showForm])

    const handleClickOutside = (event: MouseEvent) => {
        if (feedbackRef.current && showForm && !feedbackRef.current.contains(event.target as Node)) {
            setShowForm(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showForm]);


    const form = <div className='card-body'>
        <div>
            <div className="form-check">
                <input
                    className="form-check-input"
                    type="radio"
                    name="feedback-type"
                    value='bugreport'
                    checked={type === 'bugreport'}
                    onChange={e => setType(e.target.value)}
                    id="flexRadioDefault1" />
                <label className="form-check-label" htmlFor="flexRadioDefault1">
                    Bug
                </label>
            </div>
            <div className="form-check mb-3">
                <input
                    className="form-check-input"
                    type="radio"
                    name="feedback-type"
                    checked={type === 'suggestion'}
                    value='suggestion'
                    onChange={e => setType(e.target.value)}
                    id="flexRadioDefault2" />
                <label className="form-check-label" htmlFor="flexRadioDefault2">
                    Suggestion
                </label>
            </div>


            <textarea className="form-control"
                placeholder='Comments'
                value={comments}
                onChange={e => setComments(e.currentTarget.value)}></textarea>
            <div className='d-flex justify-content-end mt-2'>
                <button className='btn btn-primary btn-sm'
                    onClick={() => {
                        setReady(false);
                        api.submitFeedback(type as Feedback['type'], comments)
                            .then(() => {
                            })
                            .catch(err => { })
                            .then(() => setCompleted(true));

                    }}
                    disabled={!ready}>Submit</button>
            </div>
        </div>
    </div>

    const success = <div className='card-body'>
        <p><strong>Success!</strong></p>
        <p>Your feedback is much appreciated and will be used to improve the website.</p>
    </div>

    return <div className='feedback-container p-2' ref={feedbackRef}>
        <div className={classNames('feedback-form', showForm ? '' : 'd-none')} >
            <div className='card'>
                <div className='card-header'>
                    <strong>Submit Feedback</strong>
                </div>
                {completed ? success : form}
            </div>
        </div>
        <span className='cursor-pointer text-primary feedback-button' onClick={() => setShowForm(!showForm)}>
            <FontAwesomeIcon icon={faInbox} size={'2x'} />
        </span>
    </div>
}
export default App